import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import './LabSectionModal.css';

/**
 * Modal générique pour afficher les sections du lab
 * Remplace l'affichage long en scroll par des modales ciblées
 */
const LabSectionModal = ({ 
  isOpen, 
  onClose, 
  sectionId, 
  title, 
  icon, 
  children,
  size = 'large' // small, medium, large, fullscreen
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const getModalSize = () => {
    switch (size) {
      case 'small': return 'lab-section-modal-small';
      case 'medium': return 'lab-section-modal-medium';
      case 'fullscreen': return 'lab-section-modal-fullscreen';
      default: return 'lab-section-modal-large';
    }
  };

  return (
    <Modal 
      open={isOpen} 
      onClose={onClose}
      className={`lab-section-modal ${getModalSize()}`}
    >
      <div className="lab-section-modal-content">
        {/* Header de la modal */}
        <div className="lab-section-modal-header">
          <div className="lab-section-modal-title-area">
            {icon && (
              <span className="lab-section-modal-icon">{icon}</span>
            )}
            <h2 className="lab-section-modal-title">{title}</h2>
          </div>
          <button 
            onClick={onClose}
            className="lab-section-modal-close"
            title={t('actions.close')}
          >
            ✕
          </button>
        </div>

        {/* Contenu de la section */}
        <div className="lab-section-modal-body">
          {children}
        </div>

        {/* Footer si nécessaire */}
        <div className="lab-section-modal-footer">
          <button 
            onClick={onClose}
            className="lab-section-modal-footer-btn"
          >
            {t('actions.close')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LabSectionModal;